// ChatMCP Auth Context - provides auth context to all child components
// This eliminates prop drilling and follows React best practices

import React, { createContext, useContext } from 'react';
import type { AuthenticationProps } from '../types/auth';

// Create the context
const ChatMCPAuthContext = createContext<AuthenticationProps | null>(null);

// Provider component
interface ChatMCPAuthProviderProps {
    authContext: AuthenticationProps;
    children: React.ReactNode;
}

export const ChatMCPAuthProvider: React.FC<ChatMCPAuthProviderProps> = ({
    authContext,
    children,
}) => {
    return (
        <ChatMCPAuthContext.Provider value={authContext}>
            {children}
        </ChatMCPAuthContext.Provider>
    );
};

// Custom hook to use the auth context
export const useChatMCPAuth = (): AuthenticationProps => {
    const context = useContext(ChatMCPAuthContext);

    if (!context) {
        throw new Error('useChatMCPAuth must be used within a ChatMCPAuthProvider');
    }

    return context;
};
